/**
 * Wstrzykuje JSON-LD schema do strony.
 * Używaj wewnątrz komponentu route lub layoutu.
 */
import { jsonLd } from "@/lib/schemas";

export function JsonLd({ data }: { data: unknown }) {
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={jsonLd(data)}
    />
  );
}
